<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Pollen"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <el-steps class="stepper-container" :active="highlightedStep" align-center finish-status="success">
                <el-step v-for="(step, index) in steps" :key="'step' + index" :title="step.name" :description="step.description" />
            </el-steps>

            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id || "-" }}</td>
                    </tr>
                    <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>SerialNo</td>
                        <td>{{ detailInfo.serialNo || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Palm</td>
                        <td>{{ arrangePassportFormat((detailInfo.palm||{}).trial, (detailInfo.palm||{}).trialPalmNumber, (detailInfo.palm||{}).progeny) }}</td>
                    </tr>
                    <tr>
                        <td>Fruit Type</td>
                        <td>{{ ((detailInfo.palm||{}).fruitType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Material</td>
                        <td>{{ ((detailInfo.progeny||{}).material||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Year</td>
                        <td>{{ detailInfo.year || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Initial Amount / g</td>
                        <td>{{ detailInfo.freshWeightInitialAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Initial Viability / %</td>
                        <td>{{ detailInfo.initialViability || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Current Amount / g</td>
                        <td>{{ detailInfo.dryWeightCurrentAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Current Viability / %</td>
                        <td>{{ detailInfo.currentViability || "-" }}</td> <!-- To be discussed -->
                    </tr>
                    <tr>
                        <td>Moisture Content / %</td>
                        <td>{{ moistureContent || "-" }}</td>
                    </tr>
                    <tr>
                        <td class="table-section" colspan="2">Status</td>
                    </tr>
                    <tr>
                        <td>Pollen Status</td>
                        <td>{{ detailInfo.status || "-" }}</td>
                    </tr>
                    

                    <tr>
                        <td class="table-section" colspan="2">Inventory</td>
                    </tr>
                    <tr>
                        <td>Stock Date</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.stockDate) }} </td>
                    </tr>
                    <tr>
                        <td>Stock Expired</td>
                        <td>{{ expireDate }}</td>
                    </tr>
                    <tr>
                        <td>Discard Date</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.discardDate) }}</td>
                    </tr>
                    <tr>
                        <td>Duration</td>
                        <td>{{ detailInfo.duration || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Remarks</td>
                        <td>{{ detailInfo.remarks || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Pollen Bottle</p>
            <pollen-bottle-simple-table ref="pb-simple-table" :pollen-id="detailInfo.id" />
            
            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import PollenBottleSimpleTable from "@/components/PollenBottle/PollenBottleSimpleTable";
import { pollenGet } from "@/api/pollen";

export default {
    components: {
        "detail-header": DetailHeader,
        "pollen-bottle-simple-table": PollenBottleSimpleTable,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            detailSteps: [
                { name: "Bagged", dateKey: "bagDate", employeeKey: "bagEmployee" },
                // { name: "Pollen QC", dateKey: "bagDate", employeeKey: "bagEmployee" },
                { name: "Harvested", dateKey: "harvestDate", employeeKey: "harvestorEmployee" },
                { name: "Processed 1", dateKey: "processDate", employeeKey: "processEmployee" },
                { name: "Processed 2", dateKey: "stockDate", employeeKey: "stockEmployee" },
            ],
            mc: null,
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        expireDate() {
            if (this.detailInfo.expireDate) {
                let days = this.$_getDaysFromDate(this.detailInfo.expireDate);
                let format_date = this.$_getMyrDateFormat(this.detailInfo.expireDate);
                return `${format_date} (${days})`;
            }
            else return "-";
        },
        steps() {
            return this.detailSteps.map(step => ({
                "name": step.name,
                "description": this.getRecordDateAndUser(this.detailInfo[step.dateKey], this.detailInfo[step.employeeKey]),
                "value": this.getIsHavingRecord(this.detailInfo[step.dateKey])
            }));
        },
        highlightedStep() {
            let lastHighlightedIndex = -1;
            this.steps.forEach((step, index) => {
                if (step.value === true) {
                    lastHighlightedIndex = index;
                }
            });
            return lastHighlightedIndex == -1 ? 0 : lastHighlightedIndex + 1;
        },
        moistureContent() {
            return this.detailInfo?.moistureContent?.toFixed(2);
        },
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await pollenGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        getRecordDateAndUser(recordDate, recordUser) {
            let date = this.$_getMyrDateFormat(recordDate);
            let user = recordUser?.name || "-";
            return `${date} by ${user}`;
        },
        getIsHavingRecord(recordDate) {
            if (recordDate) {
                return true;
            }
            else return false;
        },
        refreshDetailPage() {
            this.getDetails();
            if (this.$refs["pb-simple-table"]) {
                this.$refs["pb-simple-table"].getAllPollenBottles();
            }
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-12) 0;
    margin-bottom: var(--space-12);
    width: 360px;
    overflow-x: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/PollenSidebar.vue